import * as yup from 'yup';
import { IRequestForm } from './types';
import { NavigationService } from '../../services/navigation';
import { Alert } from '../../services/alert/index.web';
import { AuthApi } from '../../services/api/auth.api';

const userNameForm: IRequestForm = {
  formStructer: {
    key: 'username',
    title: 'username',
    description: '',
    components: [
      {
        type: 'text',
        name: 'username',
        label: 'User name',
        placeholder: 'User name',
        validation: yup.string().required('User name is required'),
      },
      {
        type: 'submit',
        name: 'request',
        label: 'SAVE',
        placeholder: '',
      },
    ],
  },
  // onSubmit: (async (data) => {
  //   await AuthApi.updateProfile(data)
  //     .then((value) => {
  //       Alert.alert('Success', value.data.message);
  //     })
  //     .catch((error) => {
  //       Alert.alert('Error', error.message);
  //     });
  // }),
};

const passwordForm: IRequestForm = {
  formStructer: {
    key: 'password',
    title: 'password',
    description: '',
    components: [
      {
        type: 'text',
        name: 'password',
        label: 'Current Password',
        placeholder: 'Current Password',
        validation: yup.string().required('Current Password is required'),
        secureTextEntry: true,
      },
      {
        type: 'text',
        name: 'new_password',
        label: 'New Password',
        placeholder: 'New Password',
        validation: yup.string()
          .required("New Password is required")
          .min(8, "At lease 8 letters")
          .matches(/[A-Z]/, "At least one capital letter")
          .matches(/[0-9\W_]/, "Contains a number or a special character"),
        secureTextEntry: true,
      },
      {
        type: 'text',
        name: 're_password',
        label: 'New Password Repeat',
        placeholder: 'New Password Repeat',
        validation: yup.string()
          .required('New Password Repeat is required')
          .oneOf([yup.ref('new_password'), ''], 'New Password Repeat must match'),
        secureTextEntry: true,
      },
      {
        type: 'submit',
        name: 'request',
        label: 'SAVE',
        placeholder: '',
      },
    ],
  },
  // onSubmit: (async (data) => {
  //   await AuthApi.updateProfile({
  //     password: data.password,
  //     new_password: data.new_password,
  //   })
  //     .then((value) => {
  //       Alert.alert('Success', value.data.message);
  //     })
  //     .catch((error) => {
  //       Alert.alert('Error', error.message);
  //     });
  // }),
};

const memberDetailsForm: IRequestForm = {
  formStructer: {
    key: 'memberDetails',
    title: 'member details',
    description: '',
    components: [
      {
        type: 'text',
        name: 'memb_sal',
        label: 'Salutation',
        placeholder: 'Salutation',
        validation: yup.string().required('Salutation is required'),
      },
      {
        type: 'text',
        name: 'memb_sur',
        label: 'Surname',
        placeholder: 'Surname',
        validation: yup.string().required('Surname is required'),
      },
      {
        type: 'text',
        name: 'memb_giv',
        label: 'Given name',
        placeholder: 'Given name',
        validation: yup.string().required('Given name is required'),
      },
      {
        type: 'text',
        name: 'alias',
        label: 'Alias',
        placeholder: 'Alias',
        validation: yup.string().required('Alias is required'),
      },
      {
        type: 'text',
        name: 'memb_chinese_sal',
        label: 'Chinese Salutation',
        placeholder: 'Chinese Salutation',
        validation: yup.string().required('Chinese Salutation is required'),
      },
      {
        type: 'text',
        name: 'memb_chinese_sur',
        label: 'Chinese Surname',
        placeholder: 'Chinese Surname',
        validation: yup.string().required('Chinese Surname is required'),
      },
      {
        type: 'text',
        name: 'memb_chinese_giv',
        label: 'Chinese Given Name',
        placeholder: 'Chinese Given Name',
        validation: yup.string().required('Chinese Given Name is required'),
      },
      // {
      //   type: 'submit',
      //   name: 'request',
      //   label: 'REQUEST UPDATE',
      //   placeholder: '',
      // },
    ],
  },
};

const squouseDetailsForm: IRequestForm = {
  formStructer: {
    key: 'spouseDetails',
    title: 'spouse details',
    description: '',
    components: [
      {
        type: 'text',
        name: 'mobile',
        label: 'Mobile',
        placeholder: 'Mobile',
        validation: yup.string().required('Mobile is required'),
      },
      {
        type: 'text',
        name: 'companyName',
        label: 'Company Name',
        placeholder: 'Company Name',
        validation: yup.string().required('Company Name is required'),
      },
      {
        type: 'text',
        name: 'businessPosition',
        label: 'Business position',
        placeholder: 'Business Position',
        validation: yup.string().required('Business position is required'),
      },
      {
        type: 'text',
        name: 'businessPhone',
        label: 'Business phone',
        placeholder: 'Business Phone',
        validation: yup.string().required('Business phone is required'),
      },
      {
        type: 'text',
        name: 'businessEmail',
        label: 'Business email',
        placeholder: 'Business Email',
        validation: yup.string().required('Business email is required'),
      },
      {
        type: 'text',
        name: 'personalEmail',
        label: 'Personal email',
        placeholder: 'Personal Email',
        validation: yup.string().required('Personal email is required'),
      },
      // {
      //   type: 'submit',
      //   name: 'request',
      //   label: 'REQUEST UPDATE',
      //   placeholder: '',
      // },
    ],
  },
};

const childrenDetailsForm: IRequestForm = {
  formStructer: {
    key: 'childrenDetails',
    title: 'children details',
    description: '',
    components: [],
  },
};

const emergencyContactForm: IRequestForm = {
  formStructer: {
    key: 'emergencyContact',
    title: 'emergency contact',
    description: '',
    components: [
      {
        type: 'text',
        name: 'contactName1',
        label: 'Contact Name 1',
        placeholder: 'Contact Name 1',
        validation: yup.string().required('Contact Name 1 is required'),
      },
      {
        type: 'text',
        name: 'phone1',
        label: 'Phone 1',
        placeholder: 'Phone 1',
        validation: yup.string().required('Phone 1 is required'),
      },
      {
        type: 'text',
        name: 'relationship1',
        label: 'Relationship 1',
        placeholder: 'Relationship 1',
        validation: yup.string().required('Relationship 1 is required'),
      },
      {
        type: 'text',
        name: 'contactName2',
        label: 'Contact Name 2',
        placeholder: 'Contact Name 2',
        validation: yup.string().required('Contact Name 2 is required'),
      },
      {
        type: 'text',
        name: 'phone2',
        label: 'Phone 2',
        placeholder: 'Phone 2',
        validation: yup.string().required('Phone 2 is required'),
      },
      {
        type: 'text',
        name: 'relationship2',
        label: 'Relationship 2',
        placeholder: 'Relationship 2',
        validation: yup.string().required('Relationship 2 is required'),
      },
      // {
      //   type: 'submit',
      //   name: 'request',
      //   label: 'REQUEST UPDATE',
      //   placeholder: '',
      // },
    ],
  },
};

const carRegistraionForm: IRequestForm = {
  formStructer: {
    title: 'car registration',
    description: '',
    components: [
      {
        type: 'text',
        name: 'license',
        label: 'License#',
        placeholder: 'License',
        validation: yup.string().required('License is required'),
      },
      {
        type: 'text',
        name: 'brand',
        label: 'Brand',
        placeholder: 'brand',
        validation: yup.string().required('brand is required'),
      },
      {
        type: 'text',
        name: 'model',
        label: 'Model',
        placeholder: 'Model',
        validation: yup.string().required('Model is required'),
      },
      {
        type: 'text',
        name: 'year',
        label: 'Year',
        placeholder: 'Year',
        validation: yup.string().required('Year is required'),
      },
      {
        type: 'text',
        name: 'color',
        label: 'Color',
        placeholder: 'Color',
        validation: yup.string().required('Color is required'),
      },
      {
        type: 'submit',
        name: 'request',
        label: 'REQUEST UPDATE',
        placeholder: '',
      },
    ],
  },
};

const vaccinationDetailsForm: IRequestForm = {
  formStructer: {
    title: 'Vaccination details',
    description: '',
    components: [
      {
        type: 'text',
        name: 'firstDose',
        label: '1st Dose',
        placeholder: 'First Dose',
        validation: yup.string().required('Dose is required'),
      },
      {
        type: 'text',
        name: 'secondDose',
        label: '2nd Dose',
        placeholder: 'Second Dose',
        validation: yup.string().required('Dose is required'),
      },
      {
        type: 'text',
        name: 'thirstDose',
        label: '3rd Dose',
        placeholder: 'Thirst Dose',
        validation: yup.string().required('Dose is required'),
      },
      {
        type: 'text',
        name: 'exception',
        label: 'Exception',
        placeholder: 'Exception',
        validation: yup.string().required('Exception is required'),
      },
      {
        type: 'text',
        name: 'date',
        label: 'Date',
        placeholder: 'Date',
        validation: yup.string().required('Date is required'),
      },
      {
        type: 'submit',
        name: 'request',
        label: 'REQUEST UPDATE',
        placeholder: '',
      },
    ],
  },
};

const requestForm = [
  userNameForm,
  passwordForm,
  memberDetailsForm,
  squouseDetailsForm,
  emergencyContactForm,
];

export default requestForm;

export const ACCOUNT_TAB = [
  {
    icon: require('../../assets/my-account-statement.png'),
    title: 'My account\nStatement',
    onPress: () => {
      NavigationService.push('AccountStatememt');
    },
  },
  {
    icon: require('../../assets/my-bookings.png'),
    title: 'My bookings',
    onPress: () => {
      NavigationService.push('Root', {
        screen: 'MyBookingsTab',
      });
    },
  },
  {
    icon: require('../../assets/my-orders.png'),
    title: 'My orders',
    onPress: () => {
      NavigationService.push('Root', {
        screen: 'MyOrdersTab',
      });
    },
  },
  {
    icon: require('../../assets/my-preferences.png'),
    title: 'My\nPreferences',
    onPress: () => {
      NavigationService.push('MyPreferences');
    },
  },
];
